var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGdscLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 39,
    viewBox: "0 0 80 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0307 19.427L32.0414 11.8979C35.0794 10.1147 36.1362 6.21804 34.353 3.17999C32.5698 0.141937 28.6732 -0.914777 25.6349 0.868428L3.17993 13.8132L19.0307 19.427Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8053 38.712C30.9848 38.712 33.1643 37.5893 34.353 35.5418C36.1362 32.5038 35.0797 28.6072 32.0414 26.8239L9.58639 13.8793C6.54835 12.0961 2.65154 13.1528 0.868323 16.1908C-0.914684 19.2289 0.1419 23.1256 3.17994 24.9088L25.6352 37.8534C26.6259 38.4479 27.7485 38.712 28.8053 38.712Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1284 38.712C52.185 38.712 53.3079 38.4479 54.2984 37.8534L76.7536 24.9087L61.1011 19.1628L47.8922 26.7578C44.8541 28.5411 43.7973 32.4379 45.5805 35.4759C46.7695 37.5893 48.949 38.712 51.1284 38.712Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5839 25.7674C75.7633 25.7674 77.9428 24.6445 79.1315 22.5972C80.9148 19.5591 79.8582 15.6625 76.8201 13.8792L54.3649 0.934493C51.3269 -0.848711 47.4303 0.208023 45.6471 3.24607C43.8638 6.28413 44.9204 10.1807 47.9585 11.9639L70.4137 24.9088C71.4044 25.5031 72.5271 25.7674 73.5839 25.7674Z",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGdscLogo);
export default __webpack_public_path__ + "static/media/gdsc-logo.609f5eb226acae8640e535e58d147dbd.svg";
export { ForwardRef as ReactComponent };